import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';
import { createCachedResource, PERFORMANCE_CACHE_TTL_MS } from './cachedResource';

export const SUMMARY_CACHE_TTL_MS = PERFORMANCE_CACHE_TTL_MS;

const summaries = createCachedResource(async (limit, event, replica, runKind) => {
  const response = await api.get(`${QUALITY_SERVICE_API_URL}/hub/sdk-performance/summary`, { params: { limit, event, replica, runKind } });
  return response.data;
});

export const clearSdkPerformanceSummaryCache = summaries.clear;

// A null replica asks for nothing, so a caller can skip a second request.
function useSdkPerformanceSummary(limit = 8, event = undefined, replica = 'all', runKind = undefined) {
  const key = replica === null ? null : JSON.stringify([limit, event ?? null, String(replica), runKind ?? null]);
  return summaries.useCachedResource(key, [limit, event, replica, runKind]);
}

export default useSdkPerformanceSummary;
